export default __webpack_public_path__ + "static/media/emptyIcon.d59cd76f.svg";